/* eslint-disable security/detect-object-injection */
import React from "react";
import { RaceStatusEnum } from "@tvg/ts-types/Race";
import type { MtpProps, FutureRace } from "./types";
import {
  getPostTimeLessThanSixtyMinutes,
  getPostTimeMoreThanSixtyMinutes,
  GetRaceOffAndOfficialText,
  getSizeVariantsStyles,
  getWeight
} from "./builder";
import { Paragraph } from "../Typography";
import { DecoratedResulted, MtpWrapper } from "./styled-components";

export const Mtp: React.FC<MtpProps> = ({
  status,
  mtp,
  postTime,
  size = "s",
  align = "left",
  qaLabel = "mtp",
  mode = "light",
  isMtpPro = false,
  futureRace = null,
  isMobile = false,
  ...props
}) => {
  const sizeVariantStyles = getSizeVariantsStyles(
    size,
    futureRace ? futureRace.mtp : mtp,
    status
  );

  if (
    [RaceStatusEnum.RACE_OFF, RaceStatusEnum.RACE_OFFICIAL].includes(status) &&
    !futureRace
  ) {
    return (
      <MtpWrapper {...props} data-mode={mode}>
        {GetRaceOffAndOfficialText(
          status,
          size,
          postTime,
          align,
          qaLabel,
          mode
        )}
      </MtpWrapper>
    );
  }

  const decoratedFutureResultProps = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    fontFamily: sizeVariantStyles.m.mtpText.fontFamily,
    fontSize: !isMtpPro
      ? sizeVariantStyles.xs.mtpExtraDates.fontSize
      : sizeVariantStyles.m.mtpExtraDates.fontSize,
    lineHeight: "125%",
    fontWeight: "500"
  };

  return mtp > 59 || futureRace ? (
    <MtpWrapper {...props}>
      <Paragraph
        data-mode={mode}
        color="--fd-colors-system-component-mtp-more-than-six-minutes"
        fontSize={sizeVariantStyles[size].mtpText.fontSize}
        fontWeight={sizeVariantStyles[size].mtpText.fontWeight}
        lineHeight={sizeVariantStyles[size].mtpText.lineHeight}
        fontFamily={sizeVariantStyles[size].mtpText.fontFamily}
        textAlign={align}
        qaLabel={qaLabel}
        margin={0}
      >
        {futureRace && !isMobile && `Next: Leg ${futureRace.raceNumber}  - `}
        {futureRace && isMobile ? (
          <DecoratedResulted {...decoratedFutureResultProps}>
            Next:
            {!isMtpPro ? (
              ` Leg ${futureRace.raceNumber}`
            ) : (
              <span>Leg {futureRace.raceNumber}</span>
            )}
          </DecoratedResulted>
        ) : (
          getPostTimeMoreThanSixtyMinutes(
            size,
            futureRace ? futureRace.postTime : postTime,
            isMtpPro
          )
        )}
      </Paragraph>
    </MtpWrapper>
  ) : (
    <MtpWrapper {...props}>
      <Paragraph
        data-mode={mode}
        color={
          mtp < 6
            ? "--fd-colors-system-component-mtp-less-than-six-minutes"
            : "--fd-colors-system-component-mtp-more-than-six-minutes"
        }
        fontFamily={sizeVariantStyles[size].mtpText.fontFamily}
        fontSize={sizeVariantStyles[size].mtpText.fontSize}
        fontWeight={getWeight(mtp, size)}
        lineHeight={sizeVariantStyles[size].mtpText.lineHeight}
        textAlign={align}
        qaLabel={qaLabel}
        margin={0}
        display={isMtpPro ? "flex" : ""}
      >
        {getPostTimeLessThanSixtyMinutes(
          size,
          mtp,
          align,
          mtp < 6
            ? "--fd-colors-system-component-mtp-less-than-six-minutes"
            : "--fd-colors-system-component-mtp-more-than-six-minutes",
          mode,
          isMtpPro
        )}
      </Paragraph>
    </MtpWrapper>
  );
};

export type { MtpProps, FutureRace };
